import { defineMessages } from "@formatjs/intl";

const messages = defineMessages({
  name: {
    id: "FeaturedProperties.Name",
    defaultMessage: "Village House {name}",
    description: "The name of the property",
  },
  detailButton: {
    id: "FeaturedProperties.DetailButton",
    defaultMessage: "Property Detail",
    description:
      "The label of the button to open property detail on the property",
  },
});

const propertyItemMessages = defineMessages({
  availableNote: {
    id: "FeaturedProperties.PropertyItem.AvailableNote",
    defaultMessage:
      "{isAvailable, select, true {Available} other {coming soon}}",
    description: "The available note of the property item",
  },
  floorPlanTitle: {
    id: "FeaturedProperties.PropertyItem.FloorPlanTitle",
    defaultMessage: "{lType} / {size}",
    description: "The title of the floorplan on the property item",
  },
  floorPlanDescription: {
    id: "FeaturedProperties.PropertyItem.FloorPlanDescription",
    defaultMessage: "from ¥{minRent, number}",
    description: "The description of the floorplan on the property item",
  },
});

const unitStatusMessages = defineMessages({
  elevator: {
    id: "FeaturedProperties.UnitStatus.Elevator",
    defaultMessage: "Elevator",
    description: "The unit status of the property item",
  },
  pet: {
    id: "FeaturedProperties.UnitStatus.Pet",
    defaultMessage: "Pet",
    description: "The unit status of the property item",
  },
  parking: {
    id: "FeaturedProperties.UnitStatus.Parking",
    defaultMessage: "Parking",
    description: "The unit status of the property item",
  },
});

export { propertyItemMessages, unitStatusMessages };
export default messages;
